import {
  StudentGuardianLinkAPIPayload,
  StudentGuardianLinkFormValues,
  StudentLinkedGuardian,
} from './type'

export function mapGuardianApiToFormData(
  data: StudentLinkedGuardian
): StudentGuardianLinkFormValues {
  return {
    parentId: data.parent_id,
    relation: data.parent_relation,
  }
}

type StudentGuardianLinkFormValuesWithStudent = StudentGuardianLinkFormValues & {
  studentId: string | number
}
export function mapGuardianFormToApiData(
  data: StudentGuardianLinkFormValuesWithStudent
): StudentGuardianLinkAPIPayload {
  return {
    student_id: data.studentId,
    parent_id: data.parentId,
    relation: data.relation,
  }
}
